// extracted by mini-css-extract-plugin
export var closeButton = "_30-3";
export var header = "_30-0";
export var link = "_30-1";
export var retryButton = "_30-2";